/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfDocumentFileDto } from "../models/AjaxResponseOfDocumentFileDto";
import type { AjaxResponseOfListOfDocumentFileDto } from "../models/AjaxResponseOfListOfDocumentFileDto";
import type { EntityFileNameUpdateInput } from "../models/EntityFileNameUpdateInput";
import type { EntityFilesBatchUploadArgs } from "../models/EntityFilesBatchUploadArgs";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class EntityDocumentAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfListOfDocumentFileDto
   * @throws ApiError
   */
  public getAll({
    entityId,
  }: {
    entityId: number;
  }): CancelablePromise<AjaxResponseOfListOfDocumentFileDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/entity-documents/{entityId}/todos",
      path: {
        entityId: entityId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfDocumentFileDto
   * @throws ApiError
   */
  public getById({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfDocumentFileDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/entity-documents/{id}",
      path: {
        id: id,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: Array<EntityFilesBatchUploadArgs>;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/entity-documents",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfListOfDocumentFileDto
   * @throws ApiError
   */
  public update({
    requestBody,
  }: {
    requestBody?: Array<EntityFileNameUpdateInput>;
  }): CancelablePromise<AjaxResponseOfListOfDocumentFileDto> {
    return this.httpRequest.request({
      method: "PATCH",
      url: "/api/front-end/v1/entity-documents",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({
    amznS3Ids,
  }: {
    amznS3Ids?: Array<string>;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/entity-documents",
      query: {
        amznS3Ids: amznS3Ids,
      },
    });
  }
}
